import { render, staticRenderFns } from "./SiteMenu.vue?vue&type=template&id=12277aa1&scoped=true&"
import script from "./SiteMenu.vue?vue&type=script&lang=js&"
export * from "./SiteMenu.vue?vue&type=script&lang=js&"
import style0 from "./SiteMenu.vue?vue&type=style&index=0&id=12277aa1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12277aa1",
  null
  
)

export default component.exports